/* eslint-disable react/prop-types */
/*
Author: Rendra Pramulia
Description: Form validation formik custom wrapper
*/

import React from 'react';
import { View } from 'react-native';
// eslint-disable-next-line no-unused-vars
import { Formik, useFormik } from 'formik';

function SociollaForm(props) {
  const {
    initialValues,
    onSubmit,
    validationSchema,
    bindSubmitForm,
    innerRef,
    enableReinitialize,
    formik,
    children,
  } = props;

  const bindSubmit = (val) => bindSubmitForm(val);

  return (
    <>
      {formik ? (
        <form onSubmit={formik.handleSubmit}>{children}</form>
      ) : (
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
          innerRef={innerRef}
          enableReinitialize={enableReinitialize}>
          {(formikProps) => {
            return (
              <>
                {bindSubmitForm && (
                  <View onLayout={() => bindSubmit(formikProps)}></View>
                )}
                {children}
              </>
            );
          }}
        </Formik>
      )}
    </>
  );
}

export default SociollaForm;
